import React, { Component } from 'react';
import Icon from '../../components/UI/Icon/Icon';
import './AttachFilePreview.css';
import styled, { css, keyframes } from 'styled-components';

/**
* @desc component for displaying the file upload preview.
* @version 
* @author Lakshmikanth 
*/
class AttachFilePreview extends Component {
  state = {
    src: null,
    type: null
  }

  /**
  * @desc initializing the component
  * @param null
  * @return null
  */

  /**
  * @desc changes preview on changing uploading file
  * @param nextProps
  * @return null
  */
  componentWillReceiveProps(nextProps) {
    if(nextProps.data.type) {
      this.loadData(nextProps.data)
    }
  }

  /**
  * @desc setting the url and type for image preview
  * @param file data
  * @return null
  */
 
  loadData(data = this.props.data) {
    if (!data) {
      return;
    }

    let reader = new FileReader();
    let type = null;
    if (data.type.match('text')) {
      type = 'text'
    } else if (data.type.match('image')) {
      type = 'image'
    } else {
      type = data.type
    }
    
    reader.onload = (e) => {
      let src = e.target.result;
      this.setState({
        src,
        type
      });
    }

    if (type === 'text') {
      reader.readAsText(data);
    } else if (type === 'image') {
      reader.readAsDataURL(data);
    } else {
      this.setState({
        src: false,
        type
      });
    }
  }

  /**
  * @desc rendering the file upload preview
  * @param event
  * @return DOM element
  */
  render() {
    let Style = styled.div`
    width: ${this.props.progressPercent[this.props.data.name]}%`;

    let preview = <Icon icon="Attached-doc" className="file-preview-icon"/>;
    return (
      <div className="dropzone-file" >
        {preview}
        <span className="attach-file-name-ellipsis" title={this.props.data.name}>{this.props.data.name}</span>
        <Icon icon="Attach-close" className="dropzone-file-remove" onClick={this.props.onRemove}/>
        <div className="progress-outer">
          {!this.props.isUploadedFile?<Style percentage={this.props.progressPercent[this.props.data.name]} className="attach-file-progress-bar"/>:''}
        </div>
      </div>
    );
  }
}

export default AttachFilePreview;


// WEBPACK FOOTER //
// ./src/hoc/AttachFile/AttachFilePreview.js